// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

let RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
let RescriptRelay_Internal = require("rescript-relay/src/RescriptRelay_Internal.bs.js");

let Types = {};

function unwrap_fragment_conversationContext(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, ["AvailableConversationContext"]);
}

let fragmentConverter = {"__root":{"conversationContext_AvailableConversationContext_context":{"f":""},"conversationContext":{"u":"fragment_conversationContext"}}};

let fragmentConverterMap = {
  fragment_conversationContext: unwrap_fragment_conversationContext
};

function convertFragment(v) {
  return RescriptRelay.convertObj(v, fragmentConverter, fragmentConverterMap, undefined);
}

let Internal = {
  fragmentConverter: fragmentConverter,
  fragmentConverterMap: fragmentConverterMap,
  convertFragment: convertFragment
};

let Utils = {};

let node = ((function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ConversationPageExistingConversation_conversation",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "conversationContext",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "context",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "ConversationsPageRelayCommon_conversationContext"
                }
              ],
              "storageKey": null
            }
          ],
          "type": "AvailableConversationContext",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ConversationV5",
  "abstractKey": null
};
})());

let wrap_fragment_conversationContext = RescriptRelay_Internal.wrapUnion;

exports.Types = Types;
exports.unwrap_fragment_conversationContext = unwrap_fragment_conversationContext;
exports.wrap_fragment_conversationContext = wrap_fragment_conversationContext;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
/* node Not a pure module */
